import {Component, Input, OnInit} from '@angular/core';
import {FormFieldError} from "@app/presentation/components/form-field/form-field.error";
import {UntypedFormControl, UntypedFormGroup, ValidationErrors} from "@angular/forms";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'custom-form-field',
  templateUrl: './form-field.component.html',
  styleUrls: ['./form-field.component.scss'],
})

// Inspired on:https://stackblitz.com/edit/error-angular-reactive-forms-wlebpq?file=src%2Fapp%2Fapp.component.html
export class FormFieldComponent implements OnInit {

  @Input() formGroup!: UntypedFormGroup;
  @Input() controlName: string = ""
  @Input() type: 'text' | 'password' | 'email' | 'number' | 'tel' = 'text';
  @Input() kind: 'input' | 'text_area' = 'input';
  @Input() id = '';
  @Input() name: string = this.id || '';
  @Input() placeholder = '';
  @Input() label = '';
  @Input() readonly: boolean = false;
  @Input() maxLength = 9999;
  @Input() minLength = 0;
  @Input() minRows:number = 10;
  @Input() hint:string = '';

  @Input() extraErrors:FormFieldError[] = [] //TODO, potser acaba desapareixent..

  @Input() passwordVisibilitySwitch = false;
  @Input() customTextError?:string| null=null;

  constructor(private translate: TranslateService) {
  }

  // HTML helpers
  objectFn = Object;
  control!:UntypedFormControl;

  hidePassword = true;

  togglePasswordVisibility() {
    this.hidePassword = !this.hidePassword;
    this.type = this.hidePassword ? 'password' : 'text';
  }

  ngOnInit() {
    this.control = this.formGroup.controls[this.controlName] as UntypedFormControl;
  }

  /**
  * Handle the input value to add custom conversion logic.
  * @param event DOM event.
  */
 onInputChange(event: Event) {
    const input = event.target as HTMLInputElement;

    // Convert input value to number if the type is 'number'.
    if (this.type === 'number') {
      const numericValue = Number(input.value);
      this.control.setValue(numericValue);
    }
  }

  // TODO acabar de posar els per defecte. tb mirar com fer els custom.
  getDefaultValidatorErrorMessage(validatorKey:string, errors:ValidationErrors): string {
    switch (validatorKey){
      case 'required':
        return this.translate.instant('form.required_field');
      case 'email':
        return this.translate.instant('form.invalid_email');
      case 'maxlength':
        let maxLength = errors[validatorKey].requiredLength
        return this.translate.instant('form.max_length',{ length: maxLength });
      case 'minlength':
        let minLength = errors[validatorKey].requiredLength
        return this.translate.instant('form.min_length',{ length: minLength });
      case 'phonePattern':
        return this.translate.instant('form.invalid_phone');
      default:
        return this.translate.instant('form.error');
    }
  }
}
